import { useState } from "react";
import OperacionesDelDeudor from "./OperacionesDelDeudor";

function SolicitudEliminarOperacion({
  datosSolicitud,
  actualizarDatosTipoSolicitud,
}) {
  const [datosEliminarOperaciones, setdatosEliminarOperaciones] = useState({
    operaciones: datosSolicitud.operaciones
  });

  function actualizarOperaciones(operaciones) {
    const nuevosDatos = {
      ...datosEliminarOperaciones,
      operaciones: operaciones,
    };
    actualizarDatos(nuevosDatos);
  }

  function actualizarDatos(nuevosDatos) {
    setdatosEliminarOperaciones(nuevosDatos);
    actualizarDatosTipoSolicitud(nuevosDatos);
  }


  return (
    <>
      <OperacionesDelDeudor
        operaciones={datosEliminarOperaciones.operaciones}
        actualizarOperaciones={actualizarOperaciones}
        permiteEditar="true"
        permiteEliminar="true"
      />
    </>
  );
}

export default SolicitudEliminarOperacion;
